import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import NoData from '../../../components/NoData/NoData';
import { setChart } from '../../../components/Filter/FilterActions';
import { setPageName } from './../../App/AppActions';
import { getData } from '../CTAActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';
import CTADetailsAccordion from '../../../components/DetailsAccordion/CTADetailsAccordion';
import WipAvgAge from '../components/WipAvgAge';
import DailyWIP from '../components/DailyWIP';
import BlockersStats from '../../Common/components/BlockersStats';

import { 
  trackTeamDashboardView, 
  trackChartPointDetailsView,
  trackHowToOpened 
} from '../../../util/mixpanel';

import CTAChart from './../components/CTAChart';

export class CTA extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        series: [],
        categories: [],
        healthZones: []
      },
      selectedPoint: {},
      width: 900,
      height: 900
    };

    this.handleChange = this.handleChange.bind(this);
    this.handlePointClick = this.handlePointClick.bind(this);
    this.contentRef = React.createRef();

    props.dispatch(setPageName('Aging Chard'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('cta');

      trackTeamDashboardView('cta');
    }

    if (this.props.data) {
      this.setDataPoint();
    }
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.dataHash != this.props.dataHash ||
        prevProps.hash != this.props.hash ||
        prevProps.enabledColors != this.props.enabledColors) &&
      this.props.dataIsLoading === false
    ) {
      this.handleChange();
    }

    if (prevProps.data !== this.props.data) {
      this.setDataPoint();
    }

    if (
      this.props.data &&
      !!this.props.data.length &&
      !this.props.dataIsLoading &&
      prevProps.dates.daysFromStart !== this.props.dates.daysFromStart
    ) {
      this.setDataPoint(this.props.dates.daysFromStart);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  setDataPoint(day = -1) {
    let data = this.props.data[0];

    if (day > -1 && day < this.props.data.length) {
      const index = this.props.data.length - day - 1;
      data = this.props.data[index];

      this.setState({
        selectedPoint: {}
      });
    }

    if (data) {
      this.setState({
        data
      });
    }
  }

  handleChange(force) {
    if (force || !this.props.dataIsLoading) {
      this.setState({
        selectedPoint: {}
      });
      this.props.getData();
    }
  }

  handlePointClick(point) {
    this.setState({
      selectedPoint: point
    });

    trackChartPointDetailsView('cta', true);
  }

  handleResize = () => {
    if (this.contentRef && this.contentRef.current) {
      this.setState({
        width: this.contentRef.current.offsetWidth,
        height: this.contentRef.current.offsetHeight
      });
    }
  }

  trackHowToCTAOpen() {
    trackHowToOpened('cta');
  }

  getBlockersFlags() {
    const { app, dashboard } = this.props;
    const showBlockers = app === 'trello' || app === 'azure' || app === 'jira' || (app === 'file' && !dashboard.isAzure);
    const blockersDisabled =
      app === 'jira' && dashboard.isBusiness && !dashboard.selectedBlockedFlag ||
      app === 'trello' &&  !dashboard.selectedBlockedFlag || 
      app === 'azure' && !dashboard.selectedBlockedFlag;
    return { showBlockers, blockersDisabled };
  }

  render() {
    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <p>Use the chart to:</p>
          <ul>
            <li>Track your current work in progress</li>
            <li>Review the state of your process in the past</li>
            <li>Evaluate your WIP and the average age of WIP consistency</li>
          </ul>
          <a
            href={`https://getnave.com/aging-chart`}
            target="_blank"
            onClick={this.trackHowToCTAOpen}
            onAuxClick={this.trackHowToCTAOpen}
            className='btn btn-secondary'
            >
              Learn more
          </a>
        </div>
      </div>
    );

    const totalItems = !this.state.data ? 0 : _.reduce(this.state.data.series, (p, c) => {
      return p + (c.data && c.data.length || 0);
    }, 0);
    const leftAdjust = (+this.props.lineChart) * 272 + (+this.props.avgChart) * 272;
    const bounds = { left: - leftAdjust, top: 112, right: this.state.width - 320 - leftAdjust, bottom: this.state.height - 290 };
    const { showBlockers, blockersDisabled } = this.getBlockersFlags();
    
    // Always take the stats for the last date in the range
    const blockersStats = showBlockers && this.props.data && !!this.props.data.length && this.props.data[0].stats;
    // In case we need Aging Replay affects the stats, uncomment
    // const blockersStats =
    //   showBlockers && this.props.data && !!this.props.data.length && 
    //   this.props.data[this.props.data.length - 1 - this.props.dates.daysFromStart];

    return (
      <div className="content-wrap" >
        <Helmet title={`Aging Chart${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`} />
        <Filter totalItems={totalItems} dateSlider enablePercentiles enableMarkBlocked enableHealthZones timeunit />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>
                Aging Chart
              </h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              <Options
                showAvgChart
                showLineChart
                showBlockers={showBlockers}
                blockersDisabled={blockersDisabled}
                options={{
                  avgChartTooltip: 'WIP Average Age',
                  lineChartTooltip: 'WIP'
                }}
              />
              <DatePicker />
            </div>
          </div>
          <div className="dashboard_details" ref={this.contentRef}>
            {this.state.data && blockersStats && this.props.blockersChart && (
              <BlockersStats id="stats" data={blockersStats} />
            )}
            {this.state.data && !!this.props.data.length && this.props.lineChart && (
              <DailyWIP
                day={this.props.dates.daysFromStart}
                data={this.props.data}
                dateFormat={this.props.dateFormat}
                widget="dwip"
              />
            )}
            {this.state.data && !!this.props.data.length && this.props.avgChart && (
              <WipAvgAge
                day={this.props.dates.daysFromStart}
                data={this.props.data}
                dateFormat={this.props.dateFormat}
                widget="waa"
              />
            )}
            <CTADetailsAccordion id="details-accordion" bounds={bounds} data={this.state.selectedPoint} />
          </div>
          <div className="diagram_details">
            <CTAChart id="CTA" data={this.state.data} onPointClick={this.handlePointClick} />
            <NoData show={this.state.data.series && !this.state.data.series.length} loading={this.props.isLoading} />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData())
  };
};

const mapStateToProps = state => {
  return {
    dateFormat: state.filters.dateFormat,
    dates: state.filters.dates,
    enabledColors: state.filters.enabledColors,
    hash: state.filters.cta.hash,
    lineChart: state.filters.cta.lineChart,
    avgChart: state.filters.cta.avgChart,
    blockersChart: state.filters.cta.blockersChart,
    data: state.cta.data,
    isLoading: state.cta.isLoading,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash,
    app: state.app.app
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CTA);
